






















































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import CartSummary from '../components/shared/CartSummary.vue';
import SizeChart from '../components/shared/SizeChart.vue';
import productsDB from '../server/init';
import ContentModal from '../components/shared/ContentModal.vue';
import StoreFilters from '../components/shared/StoreFilters.vue';

 @Component({
   components: {
     CartSummary,
     StoreFilters,
     ContentModal,
     SizeChart
   }
 })
 export default class ProductDetail extends Vue {
    private screenSize: number = screen.width;
    private showCartModal: boolean = false;
    private showSizeChartModal:boolean = false;
    private sizeLabel: boolean = true;
    @Watch('screenSize')
        private onchange(val: number, oldVal: number) {
          this.screenSize = val;
        }


   data() {
     return {
       route: this.$route.name,
       prodSlug:this.$route.params.product,
       productId: '',
       productTitle: '',
       productPrice: null,
       productCategory: this.$route.params.category,
       productSubCategory: this.$route.params.subCategory,
       productFilter: this.$route.params.filter,
       productQuantity: null,
       mobileProductHero: '',
       mobileProductThumbFront: '',
       mobileProductThumbBack: '',
       altTag: '',
       activeProducts: [],
       categories: [],
       activeFront: true,
       activeBack: false,
       productColors: [],
       activeIndex: null,
       selectedColor: '',
       productSizes: [],
       productSizeError: '',
       productSize: '',
       productDescription: '',
       productOnSale: false,
       productSalePrice: ''
     }
   }

   addItemToCart() {
     let item = {
       id: this.$data.productId,
       name: this.$data.productTitle,
       price: this.$data.productPrice,
       quantity: this.$data.productQuantity = 1,
       size: this.$data.productSize
     }
     if(this.$data.productSizes.length > 0) {
       if(this.$data.productSize) {
        this.$store.dispatch('addItemToCart', item);
        this.showCartModal = true;
        this.$emit('modalOpen');
        this.$data.productSizeError = '';
       } else {
         this.$data.productSizeError = 'Please select a size';
       }
     } else {
        this.$store.dispatch('addItemToCart', item);
        this.showCartModal = true;
        this.$emit('modalOpen');
     }
   }

   openSizeChartModal() {
     this.showSizeChartModal = true;
   }

   closeSizeChartModal() {
     this.showSizeChartModal = false;
   }

   heroImageSwap(view) {
     if(view === 'front') {
       this.$data.mobileProductHero = this.$store.getters.getActiveStoreProduct.mobileHeroFront;
       this.$data.activeFront = true;
       this.$data.activeBack = false;
     }
     if(view === 'back') {
       this.$data.mobileProductHero = this.$store.getters.getActiveStoreProduct.mobileHeroBack;
       this.$data.activeFront = false;
       this.$data.activeBack = true;
      }
    }

    closeCartModal() {
      this.showCartModal = false;
      this.$emit('modalClosed');
    }

    setNewProductColor(color, index) {
      this.$store.dispatch('setStoreSubCategories');
      let productColors = this.$store.getters.getActiveProducts;
      if(productColors) {
        for(let i = 0; i < productColors.length; i++){
          if(productColors[i].hex === color.hex) {
            this.setActiveProduct(productColors[i]);
            this.$data.activeFront = true;
            this.$data.activeBack = false;
            this.$data.activeIndex = index;
            this.$data.selectedColor = color.color;
            this.$data.productSalePrice = productColors[i].price
            let discount: number = productColors[i].price  * .15;
            this.$data.productSalePrice = (productColors[i].price - discount).toFixed(2);
          }
        }
      }
    }

    setActiveProduct(product) {
      this.$store.dispatch('setActiveStoreProduct', product );
      this.$store.dispatch('updateStoreSubCategory', product.subCategory);
      this.$store.dispatch('updateStoreFilter', product.filter);
      this.$data.productId = this.$store.getters.getActiveStoreProduct.ID;
      this.$data.mobileProductHero = this.$store.getters.getActiveStoreProduct.mobileHeroFront;
      this.$data.productTitle = this.$store.getters.getActiveStoreProduct.title;
      this.$data.mobileProductThumbFront = this.$store.getters.getActiveStoreProduct.mobileThumbFront;
      this.$data.mobileProductThumbBack = this.$store.getters.getActiveStoreProduct.mobileThumbBack;
      this.$data.productPrice = this.$store.getters.getActiveStoreProduct.price;
      this.$data.productDescription = this.$store.getters.getActiveStoreProduct.description;
      this.$data.productOnSale = this.$store.getters.getActiveStoreProduct.onSale;
      const colors = this.$store.getters.getActiveStoreProduct.colors;
    }

    setProductSize(size){
      this.sizeLabel = false;
      this.$data.productSizeError = '';
    }



  created() {

    if(this.$store.state.storeCategories < 1){
      this.$store.dispatch('setStoreCategories');
    }



    productsDB.collection('storeCategories').get()
    .then((snapshot) => {
      snapshot.forEach((doc) => {
        const categories = doc.data();
        const products = categories.products;

        if(categories.category && categories.category === this.$data.productCategory){
          if(categories.filters) {
            for(let i = 0; i < categories.filters.length; i++) {
              if(categories.filters[i].title == this.$data.productFilter) {
                this.$store.dispatch('updateStoreCategories', categories);
                this.$store.dispatch('updateStoreSubCategory', this.$data.productSubCategory);
                this.$store.dispatch('updateStoreFilter', categories.filters[i].title);
              }
            }
          }
          else {
            this.$store.dispatch('updateStoreCategories', categories);
          }
        }
        if(products) {
          for(let x = 0; x < products.length; x++){
            if(products[x].slug === this.$data.prodSlug){
              this.$data.selectedColor = products[x].color;
              this.$store.dispatch('setActiveStoreProduct', products[x]);
              this.$data.productId = this.$store.getters.getActiveStoreProduct.ID;
              this.$data.mobileProductHero = this.$store.getters.getActiveStoreProduct.mobileHeroFront;
              this.$data.productTitle = this.$store.getters.getActiveStoreProduct.title;
              this.$data.mobileProductThumbFront = this.$store.getters.getActiveStoreProduct.mobileThumbFront;
              this.$data.mobileProductThumbBack = this.$store.getters.getActiveStoreProduct.mobileThumbBack;
              this.$data.productPrice = this.$store.getters.getActiveStoreProduct.price;
              this.$data.productOnSale = this.$store.getters.getActiveStoreProduct.onSale;
              const colors = this.$store.getters.getActiveStoreProduct.colors;
              const sizes = this.$store.getters.getActiveStoreProduct.sizes;
              this.$data.productDescription = this.$store.getters.getActiveStoreProduct.description;
              if(colors){
                for(let i = 0; i < colors.length; i++) {
                  this.$data.productColors.push(colors[i]);
                }
              }
              if(sizes) {
                for(let x = 0; x < sizes.length; x++){
                  this.$data.productSizes.push(sizes[x]);
                }
              }
              if(this.$data.productOnSale) {
                let price = parseFloat(this.$data.productPrice).toFixed(2);
                // @ts-ignore
                let discount: number = price * .15;
                // @ts-ignore
                this.$data.productSalePrice = (price - discount).toFixed(2);
              }
            }
          }
        }
      });
    });


  }



 }
